import type { HtmlSignals } from "./security-analysis";

// Un template détaché garde ses enfants inertes : pas d'exécution, d'images chargées,
// de cadres ouverts ou d'éléments insérés dans le document de l'application.
export function inspectSecurityHtml(html: string): HtmlSignals {
  const result: HtmlSignals = { links: [], remoteImages: 0, smallImages: 0, remoteStyles: 0,
    hiddenCount: 0, hiddenSamples: [], activeElements: 0, limited: html.length > 1_000_000 };
  if (!html) return result;
  const template = document.createElement("template");
  template.innerHTML = html.slice(0, 1_000_000);
  const nodes = template.content.querySelectorAll("*");
  if (nodes.length > 10_000) result.limited = true;
  const remote = (value: string) => /^(?:https?:)?\/\//i.test(value.trim());
  for (const node of [...nodes].slice(0, 10_000)) {
    const style = node.getAttribute("style") ?? "";
    if (["A", "AREA"].includes(node.tagName) && node.hasAttribute("href")) {
      if (result.links.length < 400) result.links.push({ href: node.getAttribute("href")!, text: (node.textContent ?? "").trim().slice(0, 500) });
      else result.limited = true;
    }
    if (node.tagName === "IMG" && remote(node.getAttribute("src") ?? "")) {
      result.remoteImages++;
      const dimension = (name: string) => {
        const value = node.getAttribute(name) ?? style.match(new RegExp("(?:^|;)\\s*" + name + "\\s*:\\s*([0-9.]+)(?:px)?\\s*(?:!important)?\\s*(?:;|$)", "i"))?.[1];
        return value != null && /^\d+(?:\.\d+)?(?:px)?$/i.test(value.trim()) ? parseFloat(value) : Infinity;
      };
      if (dimension("width") <= 2 || dimension("height") <= 2) result.smallImages++;
    }
    const css = style + (node.tagName === "STYLE" ? node.textContent ?? "" : "");
    result.remoteStyles += [...css.matchAll(/url\(\s*["']?(?:https?:)?\/\//gi)].length;
    if (node.tagName === "LINK" && remote(node.getAttribute("href") ?? "")) result.remoteStyles++;
    const hidden = node.hasAttribute("hidden") || /(?:^|;)\s*(?:display\s*:\s*none|visibility\s*:\s*hidden|opacity\s*:\s*0(?:\.0+)?\s*(?:!important\s*)?(?:;|$)|font-size\s*:\s*0(?:px|pt|em|rem|%)?(?:\s|;|!|$)|mso-hide\s*:\s*all)/i.test(style);
    if (hidden && !["SCRIPT", "STYLE"].includes(node.tagName)) {
      result.hiddenCount++;
      if (result.hiddenSamples.length < 5) {
        const text = (node.textContent ?? "").slice(0, 1000).replace(/\s+/g, " ").trim();
        if (text) result.hiddenSamples.push(text.slice(0, 300));
      }
    }
    if (["SCRIPT", "FORM", "IFRAME", "OBJECT", "EMBED"].includes(node.tagName)) result.activeElements++;
  }
  return result;
}
